<template>
    <div class="w-full">
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[70%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <h2 class="text-3xl font-medium text-center mb-[40px] text-black underline">ATTESTATION DE DEPART EN CONGES MATERNITE</h2>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Name</th>
                            <th class="text-2xl text-black font-normal">{{ nom ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Department serviced</th>
                            <th class="text-2xl text-black font-normal">{{ departement ?? "" }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th colspan="2" class="text-center text-black text-3xl font-semibold">DATES/REASONS OF ABSENCE</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">From</th>
                            <th class="text-2xl text-black font-normal">{{ startDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">To</th>
                            <th class="text-2xl text-black font-normal">{{ endDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Return Date</th>
                            <th class="text-2xl text-black font-normal">{{ returnDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Number of Days</th>
                            <th class="text-2xl text-black font-normal">{{ nbJour ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Reason</th>
                            <th class="text-2xl text-black font-normal">{{ raison ?? "" }}</th>
                        </tr>
                    </tbody>
                </table>
                <p class="mb-4 text-gray-700 mt-28 ml-8">
                    Consultant’s signature: .............................
                </p>
                <p class="mb-4 text-gray-700 mt-28 ml-8">
                    Supervisor signature: .............................
                </p>
                <p class="mb-4 text-gray-700 mt-28 ml-8">
                    HR Office signature: .............................
                </p>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "ConsultantAbsenceNotValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            nom: null,
            departement: null,
            startDate: null,
            endDate: null,
            returnDate: null,
            nbJour: null,
            raison: null,
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.departement= JSON.parse(data.data["data"]["content"]).departement
                    this.startDate= JSON.parse(data.data["data"]["content"]).startDate
                    this.endDate= JSON.parse(data.data["data"]["content"]).endDate
                    this.returnDate= JSON.parse(data.data["data"]["content"]).returnDate
                    this.nbJour= JSON.parse(data.data["data"]["content"]).nbJour
                    this.raison= JSON.parse(data.data["data"]["content"]).raison
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            const signature = localStorage.getItem("signature") ?? undefined;
            if(!signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : localStorage.getItem("signature")
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        console.log(response.data);
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>